import { useEffect, useMemo, useState } from 'react';
import { fetchModels } from '../lib/api';
import type { ModelOption } from '../types/chat';

const MODEL_STORAGE_KEY = 'workers-ai-selected-model';

export function useModels() {
  const [models, setModels] = useState<ModelOption[]>([]);
  const [selectedModel, setSelectedModelState] = useState(() => localStorage.getItem(MODEL_STORAGE_KEY) || '');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    fetchModels()
      .then(({ models: available, defaultModel }) => {
        if (!active) return;
        setModels(available);
        setSelectedModelState((current) => {
          const next = available.some((model) => model.alias === current) ? current : defaultModel;
          localStorage.setItem(MODEL_STORAGE_KEY, next);
          return next;
        });
        setError('');
      })
      .catch((reason: unknown) => {
        if (!active) return;
        setError(reason instanceof Error ? reason.message : 'Gagal memuat model.');
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  const setSelectedModel = (alias: string) => {
    setSelectedModelState(alias);
    localStorage.setItem(MODEL_STORAGE_KEY, alias);
  };

  const selected = useMemo(
    () => models.find((model) => model.alias === selectedModel) ?? null,
    [models, selectedModel],
  );

  return { models, selectedModel, selected, setSelectedModel, loading, error };
}
